module.exports = __webpack_public_path__ + "static/one-stop-destination-171674a36daa98aad6a989b64675b0dc.png";